import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import {
  CreateProductInput,
  CreateProductResponse,
  DeleteProductResponse,
  GetProductByIdResponse,
  GetProductListInput,
  GetProductListResponse,
  UpdateProductInput,
  UpdateProductStatusInput,
  UpdateStatusProductResponse
} from './interface'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'

export const crateProduct = async (
  input: CreateProductInput
): Promise<CreateProductResponse> => {
  const data: AxiosResponse<CreateProductResponse> = await httpClient
    .post(API.createProduct, input)
    .catch((error) => handleResponseError(error))
  return data.data
}



export const getProductList = async (
  input: GetProductListInput
): Promise<GetProductListResponse> => {
  const data: AxiosResponse<GetProductListResponse> = await httpClient
    .post(API.getProductList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteProduct = async (
  id: string
): Promise<DeleteProductResponse> => {
  const data: AxiosResponse<DeleteProductResponse> = await httpClient
  .delete(API.deleteProduct + `${id}`)
  .catch((error) => handleResponseError(error))
  return data.data
}


export const getProductById = async (
  productId: string
): Promise<GetProductByIdResponse> => {
  const data: AxiosResponse<GetProductByIdResponse> = await httpClient
    .get(API.getProductById + productId)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const updateProduct = async (
  input: UpdateProductInput
): Promise<CreateProductResponse> => {
  const data: AxiosResponse<CreateProductResponse> = await httpClient
    .post(API.createProduct, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const updateStatusProduct = async (
  input: UpdateProductStatusInput
): Promise<UpdateStatusProductResponse> => {
  const data: AxiosResponse<UpdateStatusProductResponse> = await httpClient
    .post(API.updateStatusProduct, input)
    .catch((error) => handleResponseError(error))
  return data.data
}